//设备监控
const deviceMonitorZh = {
  deMonLang: {
    请输入站点名称搜索: '请输入站点名称搜索',
    暂无数据: '暂无数据',
    主机: '主机',
    从机: '从机',
    未知: '未知',
    请输入系统名称搜索: '请输入系统名称搜索',

    数据分析: '数据分析',
    字段选择: '字段选择',
    请选择字段: '请选择字段',
    时间范围: '时间范围',
    开始日期: '开始日期',
    结束日期: '结束日期',
    查询: '查询',
    重置: '重置',
    查询结果: '查询结果',
    末次数据时间: '末次数据时间',

    '时间范围只能选择1-7天': '时间范围只能修改1-7天',
    单体电压: '单体电压',
    单体温度: '单体温度',
    支路: '支路',
    消防探头: '消防探头'
  },
  //pcs
  pcsLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    故障复位: '故障复位',
    设备状态: '设备状态',
    运行: '运行',
    停机: '停机',
    运行状态: '运行状态',
    充电: '充电',
    放电: '放电',
    待机: '待机',
    工作状态: '工作状态',
    并网: '并网',
    离网: '离网',
    并网状态: '并网状态',
    正常: '正常',
    故障: '故障',
    故障状态: '故障状态',
    手动: '手动',
    远程: '远程',
    控制模式: '控制模式',
    离线: '离线',
    与EMS通信: '与EMS通信',
    设备数据: '设备数据',
    当日充电量: '当日充电量',
    当日放电量: '当日放电量',
    交流频率: '交流频率',
    总交流有功功率: '总交流有功功率',
    总交流无功功率: '总交流无功功率',
    总交流视在功率: '总交流视在功率',
    总交流功率因数: '总交流功率因数',
    A相有功功率: 'A相有功功率',
    B相有功功率: 'B相有功功率',
    C相有功功率: 'C相有功功率',
    A相无功功率: 'A相无功功率',
    B相无功功率: 'B相无功功率',
    C相无功功率: 'C相无功功率',
    A相视在功率: 'A相视在功率',
    B相视在功率: 'B相视在功率',
    C相视在功率: 'C相视在功率',
    AB电压: 'AB电压',
    BC电压: 'BC电压',
    CA电压: 'CA电压',
    AB电流: 'AB电流',
    BC电流: 'BC电流',
    CA电流: 'CA电流',
    A相电压: 'A相电压',
    B相电压: 'B相电压',
    C相电压: 'C相电压',
    A相电流: 'A相电流',
    B相电流: 'B相电流',
    C相电流: 'C相电流',
    PCS模块温度: 'PCS模块温度',
    PCS环境温度: 'PCS环境温度',
    PCS散热器温度: 'PCS散热器温度',
    A1模块温度: 'A1模块温度',
    B1模块温度: 'B1模块温度',
    C1模块温度: 'C1模块温度',
    A2模块温度: 'A2模块温度',
    B2模块温度: 'B2模块温度',
    C2模块温度: 'C2模块温度',
    进风口温度: '进风口温度',
    出风口温度: '出风口温度',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    DCDC故障状态字: 'DCDC故障状态字',
    支路一: '支路一',
    直流功率: '直流功率',
    直流电压: '直流电压',
    直流电流: '直流电流',
    支路数据: '支路数据',
    支路: '支路',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    确认提示: '确认提示',
    请确认是否下发故障复位指令该指令每30秒内只可下发一次: '请确认是否下发故障复位指令，该指令每 30 秒内只可下发一次！',
    请选择时间: '请选择时间！'
  },
  //电表
  eleLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    设备数据: '设备数据',
    总有功功率: '总有功功率',
    无功功率: '无功功率',
    视在功率: '视在功率',
    功率因数: '功率因数',
    A相有功功率: 'A相有功功率',
    B相有功功率: 'B相有功功率',
    C相有功功率: 'C相有功功率',
    A相电压: 'A相电压',
    B相电压: 'B相电压',
    C相电压: 'C相电压',
    A相电流: 'A相电流',
    B相电流: 'B相电流',
    C相电流: 'C相电流',
    电网频率: '电网频率',
    电流互感器变比: '电流互感器变比',
    电压互感器变比: '电压互感器变比',
    电量数据: '电量数据',
    类别: '类别',
    总: '总',
    尖: '尖',
    峰: '峰',
    平: '平',
    谷: '谷',
    日正向总电能: '日正向总电能',
    日反向总电能: '日反向总电能',
    累计正向总电能: '累计正向总电能',
    累计反向总电能: '累计反向总电能',
    累计正向总电能原始值: '累计正向总电能原始值',
    累计反向总电能原始值: '累计反向总电能原始值',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //BMS
  bmsLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    充电: '充电',
    放电: '放电',
    空闲: '空闲',
    充放电状态: '充放电状态',
    正常: '正常',
    禁充: '禁充',
    禁放: '禁放',
    待机: '待机',
    停机: '停机',
    堆状态: '堆状态',
    与PCS通信: '与PCS通信',
    与EMS通信: '与EMS通信',
    离线: '离线',
    设备数据: '设备数据',
    总电压: '总电压',
    总电流: '总电流',
    SOC: 'SOC',
    SOH: 'SOH',
    充电限制功率: '充电限制功率',
    放电限制功率: '放电限制功率',
    可充电量: '可充电量',
    可放电量: '可放电量',
    平均温度: '平均温度',
    平均电压: '平均电压',
    绝缘值: '绝缘值',
    正极绝缘值: '正极绝缘值',
    负极绝缘值: '负极绝缘值',
    最高温度: '最高温度',
    簇: '簇',
    组: '组',
    单体: '单体',
    最低温度: '最低温度',
    最高电压: '最高电压',
    最低电压: '最低电压',
    簇状态: '簇状态',
    并网: '并网',
    离网: '离网',
    并网状态: '并网状态',
    电压: '电压',
    电流: '电流',
    功率: '功率',
    主正接触器: '主正接触器',
    断开: '断开',
    闭合: '闭合',
    主负接触器: '主负接触器',
    高压箱温度: '高压箱温度',
    故障状态字: '故障状态字',
    单体电池: '单体电池',
    请选择: '请选择',
    序号: '序号',
    单位: '单位',
    最高: '最高',
    最低: '最低',
    均衡: '均衡',
    暂无数据: '暂无数据',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    电池堆视图: '电池堆视图',
    电池簇视图: '电池簇视图',
    单体电池视图: '单体电池视图',
    电池单体电压: '电池单体电压',
    单体电压: '单体电压',
    电池单体温度: '电池单体温度',
    单体温度: '单体温度',
    请选择时间: '请选择时间！',
    直流脱扣: '直流脱扣',
    交流脱扣: '交流脱扣',
    BMS控制: 'BMS控制',
    'BMS 控制': 'BMS 控制',
    BMS软件复位: 'BMS软件复位',
    '请确认是否下发该指令，指令每30秒内可下发一次！': '请确认是否下发该指令，指令每30秒内可下发一次！'
  },
  //空调
  airLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    运行: '运行',
    待机: '待机',
    工作状态: '工作状态',
    停止: '停止',
    室内风机: '室内风机',
    室外风机: '室外风机',
    未选配: '未选配',
    应急风机: '应急风机',
    压缩机: '压缩机',
    电加热: '电加热',
    排氢状态: '排氢状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    送风: '送风',
    制冷: '制冷',
    制热: '制热',
    除湿: '除湿',
    工作模式: '工作模式',
    故障状态: '故障状态',
    故障: '故障',
    正常: '正常',
    设备数据: '设备数据',
    电流: '电流',
    交流电压: '交流电压',
    直流电压: '直流电压',
    盘管温度: '盘管温度',
    柜外温度: '柜外温度',
    柜内温度: '柜内温度',
    冷凝温度: '冷凝温度',
    融霜温度: '融霜温度',
    排气温度: '排气温度',
    出风温度: '出风温度',
    回风温度: '回风温度',
    柜内湿度: '柜内湿度',
    制热开启温度: '制热开启温度',
    制热关闭温度: '制热关闭温度',
    制冷开启温度: '制冷开启温度',
    制冷关闭温度: '制冷关闭温度',
    高温告警温度: '高温告警温度',
    低温告警温度: '低温告警温度',
    高湿告警点: '高湿告警点',
    除湿开启温度: '除湿开启温度',
    除湿关闭温度: '除湿关闭温度',
    除湿开启湿度: '除湿开启湿度',
    除湿关闭湿度: '除湿关闭湿度',
    内风机转速: '内风机转速',
    外风机转速: '外风机转速',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    温度参数设置: '温度参数设置',
    '点击“确定”按钮前，请确认参数是否正确！': '点击“确定”按钮前，请确认参数是否正确！',
    制冷启动温度: '制冷启动温度',
    制热启动温度: '制热启动温度',
    取消: '取消',
    确定: '确定',
    空调强控: '空调强控',
    强控模式下部分控制能力互斥无法同时开启: '强控模式下，部分控制能力互斥，无法同时开启!',
    如需解除强控指令请选择自动模式并应用以恢复到自动运行状态: '如需解除强控指令，请选择“自动模式”并应用,以恢复到自动运行状态！',
    控制模式: '控制模式',
    控制类别: '控制类别',
    清除强控指令并执行设备自动模式: '清除强控指令，并执行设备自动模式',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    强控模式: '强控模式',
    自动模式: '自动模式',
    开机: '开机',
    关机: '关机',
    加热: '加热',
    制冷: '制冷',
    送风: '送风',
    待机: '待机',
    请输入制冷启动温度: '请输入制冷启动温度',
    '制冷启动温度数字范围 -100 - 100': '制冷启动温度数字范围 -100 - 100',
    小数点后不允许超过1位: '小数点后不允许超过1位',
    请输入制冷关闭温度: '请输入制冷关闭温度',
    '制冷关闭温度数字范围 -100 - 100': '制冷关闭温度数字范围 -100 - 100',
    请输入制热启动温度: '请输入制热启动温度',
    '制热启动温度数字范围 -100 - 100': '制热启动温度数字范围 -100 - 100',
    请输入制热关闭温度: '请输入制热关闭温度',
    '制热关闭温度数字范围 -100 - 100': '制热关闭温度数字范围 -100 - 100',
    请输入高温告警温度: '请输入高温告警温度',
    '高温告警温度数字范围 -100 - 100': '高温告警温度数字范围 -100 - 100',
    请输入低温告警温度: '请输入低温告警温度',
    '低温告警温度数字范围 -100 - 100': '低温告警温度数字范围 -100 - 100',
    请选择时间: '请选择时间！',
    提示: '提示',
    请确认是否应用空调温度参数: '请确认是否应用空调温度参数',
    应用: '应用',
    取消: '取消',
    '制冷启动温度 - 制冷关闭温度 ≥ 1': '制冷启动温度 - 制冷关闭温度 ≥ 1',
    '制热关闭温度- 制热启动温度 ≥ 1': '制热关闭温度- 制热启动温度 ≥ 1',
    请选择控制类别: '请选择控制类别',
    请选择控制模式: '请选择控制模式'
  },
  //箱变
  boxLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    运行: '运行',
    故障: '故障',
    待机: '待机',
    工作状态: '工作状态',
    合闸: '合闸',
    分闸: '分闸',
    高压分合闸状态: '高压分合闸状态',
    就地: '就地',
    远方: '远方',
    远方就地状态: '远方就地状态',
    设备数据: '设备数据',
    高压IA: '高压IA',
    高压IB: '高压IB',
    高压IC: '高压IC',
    高压3IO: '高压3IO',
    低压: '低压',
    低压UAN: '低压UAN',
    低压UBN: '低压UBN',
    低压UCN: '低压UCN',
    低压UAB: '低压UAB',
    低压IA: '低压IA',
    低压IB: '低压IB',
    低压UBC: '低压UBC',
    低压UCA: '低压UCA',
    低压IC: '低压IC',
    低压3IO: '低压3IO',
    低压频率: '低压频率',
    低压有功功率: '低压有功功率',
    低压无功功率: '低压无功功率',
    温度: '温度',
    油温: '油温',
    低压功率因数: '低压功率因数',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //光伏
  phoLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    光伏强控: '光伏强控',
    设备复位: '设备复位',
    设备状态: '设备状态',
    运行: '运行',
    停机: '停机',
    运行状态: '运行状态',
    初始化: '初始化',
    等待: '等待',
    正常: '正常',
    故障: '故障',
    烧录: '烧录',
    并网: '并网',
    离网: '离网',
    自检: '自检',
    工作状态: '工作状态',
    故障状态: '故障状态',
    与EMS通信: '与EMS通信',
    离线: '离线',
    设备数据: '设备数据',
    日发电量: '日发电量',
    功率因数: '功率因数',
    R相电压: 'R相电压',
    S相电流: 'S相电流',
    TR线电压: 'TR线电压',
    直流电流: '直流电流',
    S相温度: 'S相温度',
    总发电量: '总发电量',
    电网频率: '电网频率',
    S相电压: 'S相电压',
    T相电流: 'T相电流',
    RS线电流: 'RS线电流',
    直流功率: '直流功率',
    T相温度: 'T相温度',
    RS线电压: 'RS线电压',
    ST线电流: 'ST线电流',
    直流电压: '直流电压',
    环境温度: '环境温度',
    无功功率: '无功功率',
    负极电压: '负极电压',
    R相电流: 'R相电流',
    ST线电压: 'ST线电压',
    TR线电流: 'TR线电流',
    R相温度: 'R相温度',
    散热器温度: '散热器温度',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    确认提示: '确认提示',
    请确认是否下发故障复位指令该指令每30秒内只可下发一次: '请确认是否下发故障复位指令，该指令每 30 秒内只可下发一次！',
    强控模式下部分控制能力互斥无法同时开启: '强控模式下，部分控制能力互斥，无法同时开启！',
    如需解除强控指令请选择自动模式并应用以恢复到自动运行状态: '如需解除强控指令，请选择“自动模式”并应用,以恢复到自动运行状态！',
    控制模式: '控制模式',
    控制类别: '控制类别',
    清除强控指令并执行设备自动模式: '清除强控指令，并执行设备自动模式',
    强控模式: '强控模式',
    自动模式: '自动模式',
    开机: '开机',
    关机: '关机',
    请选择控制模式: '请选择控制模式！',
    请选择控制类别: '请选择控制类别！'
  },
  //消防
  fireLang: {
    消防开关控制: '消防开关控制',
    开启: '开启',
    关闭: '关闭',
    开: '开',
    关: '关',
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    运行: '运行',
    待机: '待机',
    运行状态: '运行状态',
    故障码: '故障码',
    暂无: '暂无',
    设备数据: '设备数据',
    CO浓度: 'CO浓度',
    氢气浓度: '氢气浓度',
    烟雾数值: '烟雾数值',
    VOC数值: 'VOC数值',
    温度数值: '温度数值',
    报警等级: '报警等级',
    '1级报警': '1级报警',
    '2级报警': '2级报警',
    '3级报警': '3级报警',
    '4级报警': '4级报警',
    无故障: '无故障',
    CO浓度报警: 'CO浓度报警',
    氢气浓度报警: '氢气浓度报警',
    VOC报警: 'VOC报警',
    烟雾报警: '烟雾报警',
    温度报警: '温度报警',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！',
    是否确认开启消防: '是否确认开启消防？',
    提示: '提示',
    是否确认关闭消防: '是否确认关闭消防？'
  },
  //风扇
  fanLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    运行: '运行',
    待机: '待机',
    工作状态: '工作状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    设备数据: '设备数据',
    风扇: '风扇',
    转速: '转速',
    温度: '温度',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //tms
  tmsLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    TMS强控: 'TMS强控',
    设备状态: '设备状态',
    空闲: '空闲',
    准备启动: '准备启动',
    运行: '运行',
    延时停机: '延时停机',
    自检: '自检',
    告警: '告警',
    TMS机组运行状态: 'TMS机组运行状态',
    制冷: '制冷',
    加热: '加热',
    自循环: '自循环',
    自动: '自动',
    停机: '停机',
    TMS运行模式: 'TMS运行模式',
    正常: '正常',
    tms故障: 'tms故障',
    故障状态: '故障状态',
    离线: '离线',
    与EMS通信: '与EMS通信',
    出水温度: '出水温度',
    进水温度: '进水温度',
    控制模式: '控制模式',
    水泵状态: '水泵状态',
    补水泵运行状态: '补水泵运行状态',
    外风机状态: '外风机状态',
    设备数据: '设备数据',
    TMS供液温度: 'TMS供液温度',
    TMS回液温度: 'TMS回液温度',
    TMS供液压力: 'TMS供液压力',
    TMS回液压力: 'TMS回液压力',
    环境温度: '环境温度',
    TMS恒温方式预设温度: 'TMS恒温方式预设温度',
    制热开启温度: '制热开启温度',
    制热关闭温度: '制热关闭温度',
    制冷开启温度: '制冷开启温度',
    制冷关闭温度: '制冷关闭温度',
    吸气温度: '吸气温度',
    板换温度: '板换温度',
    冷凝盘管温度: '冷凝盘管温度',
    进出水压差值: '进出水压差值',
    高压侧压力值: '高压侧压力值',
    低压侧压力值: '低压侧压力值',
    电子膨胀阀开度: '电子膨胀阀开度',
    交流供电电压: '交流供电电压',
    压缩机转速: '压缩机转速',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    强控模式下部分控制能力互斥无法同时开启: '强控模式下，部分控制能力互斥，无法同时开启！',
    如需解除强控指令请选择自动模式并应用以恢复到自动运行状态: '如需解除强控指令，请选择“自动模式”并应用,以恢复到自动运行状态！',
    控制类别: '控制类别',
    清除强控指令并执行设备自动模式: '清除强控指令，并执行设备自动模式',
    取消: '取消',
    确定: '确定',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    请选择时间: '请选择时间！',
    强控模式: '强控模式',
    自动模式: '自动模式',
    开机: '开机',
    关机: '关机',
    待机: '待机',
    请选择控制模式: '请选择控制模式！',
    请选择控制类别: '请选择控制类别！'
  },
  //外设
  exterLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    急停状态: '急停状态',
    正常: '正常',
    急停: '急停',
    消防触发: '消防触发',
    消防状态: '消防状态',
    温感状态: '温感状态',
    异常: '异常',
    门禁状态: '门禁状态',
    开启: '开启',
    关闭: '关闭',
    浸水: '浸水',
    水浸状态: '水浸状态',
    烟感状态: '烟感状态',
    喷洒: '喷洒',
    消防喷洒: '消防喷洒',
    火灾: '火灾',
    火灾状态: '火灾状态',
    故障: '故障',
    消防设备: '消防设备',
    断路器: '断路器',
    pcs状态信号: 'pcs状态信号', //缺失
    关机: '关机',
    送风: '送风',
    柜体风机反馈: '柜体风机反馈',
    辅电信号: '辅电信号',
    触发: '触发',
    声光报警器: '声光报警器',
    PCS触发信号: 'PCS触发信号',
    门禁灯: '门禁灯',
    断路器驱动: '断路器驱动',
    空调干节点: '空调干节点',
    消防干节点: '消防干节点',
    风扇继电器: '风扇继电器',
    显示屏控制: '显示屏控制',
    充电桩控制: '充电桩控制',

    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //除湿器
  moisLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    停止: '停止',
    运行中: '运行中',
    工作状态: '工作状态',
    控湿状态: '控湿状态',
    控温状态: '控温状态',
    正常: '正常',
    故障: '故障',
    故障状态: '故障状态',
    未运行: '未运行',
    运行中: '运行中',
    除霜状态: '除霜状态',
    自动: '自动',
    手动: '手动',
    控湿手自动模式: '控湿手自动模式',
    控温手自动模式: '控温手自动模式',
    离线: '离线',
    与EMS通信: '与EMS通信',
    设备数据: '设备数据',
    环境温度: '环境温度',
    外部温度传感器故障状态: '外部温度传感器故障状态',
    内部温度: '内部温度',
    内部温度传感器故障状态: '内部温度传感器故障状态',
    温度启动值: '温度启动值',
    温度关闭值: '温度关闭值',
    湿度: '湿度',
    湿度传感器故障状态: '湿度传感器故障状态',
    除湿启动值: '除湿启动值',
    除湿关闭值: '除湿关闭值',
    控温方式: '控温方式',
    降温: '降温',
    升温: '升温',
    风机故障状态: '风机故障状态',

    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //ups
  upsLang: {
    UPS开关控制: 'UPS开关控制',
    开启: '开启',
    关闭: '关闭',
    放电测试: '放电测试',
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    UPS运行状态: 'UPS运行状态',
    关机: '关机',
    运行: '运行',
    上电状态: '上电状态',
    待机状态: '待机状态',
    旁路状态: '旁路状态',
    市电工作状态: '市电工作状态',
    电池供电状态: '电池供电状态',
    测试自检放电状态: '测试自检放电状态',
    故障状态: '故障状态',
    转换器: '转换器',
    经济状态: '经济状态',
    关机状态: '关机状态',
    保留: '保留',
    UPS状态: 'UPS状态',
    在线: '在线',
    后备: '后备',
    UPS类型: 'UPS类型',

    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    不正常: '不正常',
    市电状态: '市电状态',
    电池电压低: '电池电压低',
    电池电压状态: '电池电压状态',
    故障: '故障',
    设备状态: '设备状态',
    设备数据: '设备数据',
    UPS温度: 'UPS温度',
    电池维持时间: '电池维持时间',
    直流电电池: '直流电电池',
    电池总压: '电池总压',
    电池温度: '电池温度',
    容量: '容量',
    电流: '电流',
    额定信息: '额定信息',
    额定总功率: '额定总功率',
    输入输出相数: '输入输出相数',
    单进单出: '单进单出',
    三进单出: '三进单出',
    三进三出: '三进三出',
    额定输入电压种类: '额定输入电压种类',
    额定电池电压: '额定电池电压',
    输出定额电压: '输出定额电压',
    输出定额电流: '输出定额电流',
    输出定额频率: '输出定额频率',
    额定电池节数: '额定电池节数',
    节: '节',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！',
    提示: '提示',
    是否确认开启UPS: '是否确认开启UPS？',
    是否确认关闭UPS: '是否确认关闭UPS？',
    是否开启放电测试: '是否开启放电测试？'
  },
  //充电桩
  chargeLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    操作日志: '操作日志',
    充电桩控制: '充电桩控制',
    设备状态: '设备状态',
    运行: '运行',
    停机: '停机',
    运行状态: '运行状态',
    正常: '正常',
    离线: '离线',
    EMS通信状态: 'EMS通信状态',
    待机: '待机',
    充电: '充电',
    充电结束: '充电结束',
    故障: '故障',
    充电枪已连接: '充电枪已连接',
    工作状态: '工作状态',
    设备数据: '设备数据',
    累计充电电量: '累计充电电量',
    充电电压: '充电电压',
    充电电流: '充电电流',
    充电功率: '充电功率',
    充电请求功率: '充电请求功率',
    最大允许充电功率: '最大允许充电功率',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    充电桩控制: '充电桩控制',
    请选择控制指令后点击确定以下发: '请选择控制指令后，点击“确定”以下发！',
    控制指令: '控制指令',
    开机: '开机',
    关机: '关机',
    请选择时间: '请选择时间！'
  },
  //环境监测
  envLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    设备数据: '设备数据',
    环境温度: '环境温度',
    环境湿度: '环境湿度',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //dcdc
  dcdcLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备状态: '设备状态',
    停机: '停机',
    运行: '运行',
    运行状态: '运行状态',
    恒流充放电: '恒流充放电',
    恒压充放电: '恒压充放电',
    恒功率充放电: '恒功率充放电',
    高压侧恒压: '高压侧恒压',
    MPPT: 'MPPT',
    工作模式: '工作模式',
    正常: '正常',
    故障: '故障',
    故障状态: '故障状态',
    离线: '离线',
    与EMS通信: '与EMS通信',
    设备数据: '设备数据',
    输入端电压: '输入端电压',
    输入端电流: '输入端电流',
    输出端电压: '输出端电压',
    输出端电流: '输出端电流',
    输入端功率: '输入端功率',
    输出端功率: '输出端功率',
    机内温度: '机内温度',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',

    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    请选择时间: '请选择时间！'
  },
  //柴发
  dieselLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    柴发控制: '柴发控制',
    设备状态: '设备状态',
    停机: '停机',
    运行: '运行',
    运行状态: '运行状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    故障: '故障',
    故障状态: '故障状态',
    报警: '报警',
    告警状态: '告警状态',
    自动: '自动',
    手动: '手动',
    测试: '测试',
    engine工作状态: 'engine工作状态',
    有效: '有效',
    无效: '无效',
    机组状态: '机组状态',
    市电状态: '市电状态',
    分闸: '分闸',
    合闸: '合闸',
    机组断路器状态: '机组断路器状态',
    市电断路器状态: '市电断路器状态',
    设备数据: '设备数据',
    发动机油压: '发动机油压',
    发动机水温: '发动机水温',
    发动机燃油油位: '发动机燃油油位',
    充电发电机电压: '充电发电机电压',
    蓄电池电压: '蓄电池电压',
    发动机转速: '发动机转速',
    发动机运行时间: '发动机运行时间',
    秒: 'Second',
    启动次数: '启动次数',
    发电机总有功功率: '发电机总有功功率',
    发电机总无功功率: '发电机总无功功率',
    发电机总视在功率: '发电机总视在功率',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    请选择控制指令后点击确定以下发: '请选择控制指令后，点击“确定”以下发！',
    控制指令: '控制指令',
    开机: '开机',
    关机: '关机',
    取消: '取消',
    确定: '确定',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    请选择时间: '请选择时间！'
  },
  //综合保护
  integratedLang: {
    末次数据时间: '末次数据时间',
    数据分析: '数据分析',
    数据导出: '数据导出',
    设备复位: '设备复位',
    设备状态: '设备状态',
    正常: '正常',
    离线: '离线',
    与EMS通信: '与EMS通信',
    故障: '故障',
    事故总信号: '事故总信号',
    过流I段跳闸: '过流I段跳闸',
    过流II段跳闸: '过流II段跳闸',
    过流III段跳闸: '过流III段跳闸',
    过流I段压板: '过流I段压板',
    过流II段压板: '过流II段压板',
    过流III段压板: '过流III段压板',
    设备数据: '设备数据',
    A相电流: 'A相电流',
    B相电流: 'B相电流',
    C相电流: 'C相电流',
    A相电压: 'A相电压',
    B相电压: 'B相电压',
    C相电压: 'C相电压',
    有功功率: '有功功率',
    无功功率: '无功功率',
    设备故障字: '设备故障字',
    故障状态字: '故障状态字',
    起止时间: '起止时间',
    开始时间: '开始时间',
    结束时间: '结束时间',
    取消: '取消',
    确定: '确定',
    提示: '提示',
    请确认是否下发设备复位指令: '请确认是否下发设备复位指令！',
    请选择时间: '请选择时间！'
  },
  //操作日志
  operationLog: {
    设备监控: '设备监控',
    充电桩: '充电桩',
    操作日志: '操作日志',
    时间范围: '时间范围',
    开始日期: '开始日期',
    结束日期: '结束日期',
    开始月份: '开始月份',
    结束月份: '结束月份',
    开始年份: '开始年份',
    结束年份: '结束年份',
    查询: '查询',
    重置: '重置',
    时间: '时间',
    操作内容: '操作内容',
    操作结果: '操作结果',
    操作账号: '操作账号',
    失败: '失败',
    成功: '成功'
  },
  //ats
  atslang: {
    EMS通讯: 'EMS通讯',
    常用电源状态: '常用电源状态',
    备用电源状态: '备用电源状态',
    '常用电源 A 相电压': '常用电源 A 相电压',
    '常用电源 B 相电压': '常用电源 B 相电压',
    '常用电源 C 相电压 V': '常用电源 C 相电压 V',
    常用电源频率: '常用电源频率',
    '备用电源 A 相电压': '备用电源 A 相电压',
    '备用电源 B 相电压': '备用电源 B 相电压',
    '备用电源 C 相电压': '备用电源 C 相电压',
    备用电源频率: '备用电源频率'
  }
}
export default deviceMonitorZh
